/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestIdleTokenV4 extends Contract<ITestIdleTokenV4> {
  getGovTokensAmounts: Call<(_user: AddressLike) => BigNumber[], ITestIdleTokenV4>
  'getGovTokensAmounts(address)': Call<(_user: AddressLike) => BigNumber[], ITestIdleTokenV4>
  govTokens: Call<(_amount: BigNumberish) => string, ITestIdleTokenV4>
  'govTokens(uint256)': Call<(_amount: BigNumberish) => string, ITestIdleTokenV4>
  redeemIdleToken: Send<(_redeemAmount: BigNumberish) => BigNumber, ITestIdleTokenV4>
  'redeemIdleToken(uint256)': Send<(_redeemAmount: BigNumberish) => BigNumber, ITestIdleTokenV4>
  token: Call<() => string, ITestIdleTokenV4>
  'token()': Call<() => string, ITestIdleTokenV4>
  tokenPrice: Call<() => BigNumber, ITestIdleTokenV4>
  'tokenPrice()': Call<() => BigNumber, ITestIdleTokenV4>
}

let ITestIdleTokenV4Bytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestIdleTokenV4Bytecode = '0x';
}

// prettier-ignore
export const ITestIdleTokenV4 = contract<ITestIdleTokenV4>(ITestIdleTokenV4Bytecode)`
  function getGovTokensAmounts(address _user) view returns (uint256[] amount_)
  function govTokens(uint256 _amount) view returns (address token_)
  function redeemIdleToken(uint256 _redeemAmount) returns (uint256 amount_)
  function token() view returns (address asset_)
  function tokenPrice() view returns (uint256 price_)
`;